// extracted by mini-css-extract-plugin
export default {"container":"selectedWorkflows_container__UyXT8","box__container":"selectedWorkflows_box__container__CPPH-","selected__box":"selectedWorkflows_selected__box__uo0jY"};